<template>
  <ul class="links">
    <li v-for="navitem in $page.props.account_navigation">
      <inertia-link
          :href="navitem.isOfficeRoute ? $officeRoute(navitem.route) : route(navitem.route)"
          :onSuccess="() => $emit('navigated')"
      >{{ navitem.title }}</inertia-link>
    </li>
    <!-- <li><a href="/">Changer de compte personnel</a></li> -->
    <li><a :href="$page.props.logout_url">Déconnexion</a></li>
  </ul>
</template>

<script>

export default {
  emits: ['navigated']
}
</script>
